export default {
  meta: {
    title: '品牌商机'
  }
};
